import Vue from 'vue';
import base64 from 'base-64';
Vue.prototype.base64 = base64;
// encode加密
// decode解密